import styled from 'styled-components';
import Wra16D from 'dc/Wra16D';

export const Wrapper = styled(Wra16D)`
  display: flex;
  width: 100%;
  background-color: transparent;
`;

export const InnerWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
